import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { environment } from 'environments/environment';

const routes: Routes = [
    {
        path: environment.langInstance == 'cz' ? 'majetek' : 'majetok',
        loadChildren: () => import('app/modules/majetok/majetok.module')
            .then(module => module.MajetokModule),
    },
    {
        path: 'travel',
        loadChildren: () => import('app/modules/travel/travel.module')
            .then(module => module.TravelModule),
    },
    {
        path: 'pzp',
        loadChildren: () => import('app/modules/pzp/pzp.module')
            .then(module => module.PzpModule),
    },
    {
        path: 'life',
        loadChildren: () => import('app/modules/life/life.module')
            .then(module => module.LifeModule),
    },
    {
        path: 'kasko',
        loadChildren: () => import('app/modules/kasko/kasko.module')
            .then(module => module.KaskoModule),
    },
    {
        path: 'zodpovednost',
        loadChildren: () => import('app/modules/zodpovednost/zodpovednost.module')
            .then(module => module.ZodpovednostModule),
    },
    {
        path: 'kasko-krupobitie',
        loadChildren: () => import('app/modules/kasko-krupobitie/kasko-krupobitie.module')
            .then(module => module.KaskoKrupobitieModule),
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes,
        {
            useHash: ((document as any).aemIntegrationAppServerURL !== undefined),
        } as ExtraOptions)
    ],
    exports: [RouterModule]
})
export class ClaimsRoutingModule { }